/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type ToDoActivities = typeof ToDoActivities[keyof typeof ToDoActivities];


export const ToDoActivities = {
  CommentTagged: 'CommentTagged',
  ToDoAssigned: 'ToDoAssigned',
  ToDoUnassigned: 'ToDoUnassigned',
  Completed: 'Completed',
  Abandoned: 'Abandoned',
} as const;
